import { PaymentMethodAddressField } from '@app/common/src/components/PlanPurchaseExperience/components/PaymentMethodAddressField'
import { Stack, Typography } from '@dtx-company/design-system/src'
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js'
import { displayPaymentMethodAddressFields } from '@app/common/src/components/PlanPurchaseExperience/constants'
import { forwardRef } from 'react'
import useTranslation from 'next-translate/useTranslation'

interface CreateBillingAddressFieldProps {
  heapId: string
  paymentMethodType?: string
  onChange: (event: StripeAddressElementChangeEvent) => void
  onFocus?: () => void
}

export const CreateBillingAddressField = forwardRef<HTMLDivElement, CreateBillingAddressFieldProps>(
  ({ heapId, paymentMethodType, onChange, onFocus }, ref) => {
    const { t } = useTranslation('payment-messages')
    return (
      <>
        {paymentMethodType && displayPaymentMethodAddressFields.includes(paymentMethodType) && (
          <Stack gap={2} ref={ref}>
            <Typography variant={'subtitleSmall'}>{t('paymentAddressTitle')}</Typography>
            <PaymentMethodAddressField
              onChange={event => onChange(event)}
              heapEventName={`${heapId}`}
              onFocus={() => {
                onFocus?.()
              }}
            />
          </Stack>
        )}
      </>
    )
  }
)

CreateBillingAddressField.displayName = 'CreateBillingAddressField'
